<template>
  <v-row>
    <v-col>
      <v-row>
        <v-col cols="10" style="padding-left: 30px">
          <h1>
            Administracion de usuarios
            {{ rol == "ADMINCC" || rol == "MANAGERCC" ? "Call Center" : "" }}
          </h1>
        </v-col>
        <v-col
        cols="2"
        class="d-flex justify-end align-center"
      >
        <v-btn
          dark
          color="#cc092f"
          rounded
          min-width="120"
          @click="$router.push('/usuario/crear')"
          v-show="canViewCreate"
        >
          Crear
        </v-btn>
      </v-col>
      </v-row>
    </v-col>

    <v-col cols="12" class="mb-10" style="padding: 30px">
  
      <Busqueda-Detallada
         @searchUpdated="handleSearch"
         :rolesPermitidos="rolesPermitidos"
         :loading="loading"
      />

      <v-card class="rounded-lg header-results">
        <v-card-title class="d-flex align-center pt-6">
          <span class="text-h6 ms-8">Resultados de la busqueda</span>
        </v-card-title>
          <v-data-table
            :headers="agentesTable"
            :items="agents"
            item-key="name"
            class="elevation-1 mt-5 results-table"
            :search="search"
            loading-text="Cargando..."
            :server-items-length="totalRegistros"
            :items-per-page="elementosPagina"
            @update:page="pagina = $event; getAgent()"
            @update:items-per-page="elementosPagina = $event; pagina = 1; getAgent()"
            :footer-props="{
              'items-per-page-options': [5, 10, 15]
            }"
          >
          <template v-slot:item.status="{ item }">
              <div v-if="item.status == -1">
                <v-chip color="red" dark>Baja</v-chip>
              </div>
              <div v-if="item.status == 0">
                <v-chip color="blue" dark>Nuevo</v-chip>
              </div>
              <div v-if="item.status == 1">
                <v-chip color="green" dark>Activo</v-chip>
              </div>
              <div v-if="item.status == 2">
                <v-chip color="orange" dark>Inactivo</v-chip>
              </div>
          </template>
            <template v-slot:item.uuid="{ item }">
              <v-icon small class="mr-2" @click="editItem(item.uuid)">
                mdi-eye
              </v-icon>
            </template>

          <template v-slot:item.roles="{ item }">
          <div v-if="Array.isArray(item.roles) && item.roles.length > 0">
                {{ item.roles.map(r => r.rol || "Desconocido").join(", ") }}
              </div>
            <div v-else>No Disponible</div>
          </template> 
        </v-data-table>
      </v-card>      
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';
import BusquedaDetallada from '@/components/commondComponents/BusquedaDetallada.vue';

export default {
  components: {
    BusquedaDetallada,
  },
  data() {
    return {
      agentes: [],
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      roles: JSON.parse(localStorage.getItem("roles")),
      loading: true,

      pagina: 1,
      elementosPagina: 10,
      totalRegistros: 0,

      filtrosActuales: {},

      search: "",
      agentesTable: [
        {
          text: "id",
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: "Usuarios", value: "nombreCompleto" },
        { text: "Estatus", value: "status" },
        { text: "Correo", value: "correo", sortable: false },
        { text: "Rol", value: "roles[0].rol" },
        { text: "Fecha de creación", value: "fechaRegistro" },
        { text: "Ver Agente", value: "uuid" },
      ],
      report: [],
      agents: [],
      rolesPermitidos: []
    };
  },

  mounted() {
    this.getAgent();
  },

  computed: {
    ...mapState('permisos', ['permisos']),
    canViewCreate() {
      return (this.permisos && 
      (this.permisos.includes('FUN_ADMINISTRACION_DE_USUARIOS_ADMINCUENTA') || 
      this.permisos.includes('FUN_ADMINISTRACION_DE_USUARIOS_COORDINADOR') ||
      this.permisos.includes('FUN_ADMINISTRACION_DE_USUARIOS_GERENTE') ||
      this.permisos.includes('FUN_ADMINISTRACION_DE_USUARIOS_SUPERVISOR')
      ));
    },
    currentRol() {
      let roles = [];
      this.roles.forEach((element) => {
        if (element.rol != null) {
          roles.push(element.rol);
        }
      });

      if (roles.length > 0) {
        return roles[0];
      } else {
        return "";
      }
    },
  },

  methods: {
    getAgent(filtros = this.filtrosActuales) {
      this.loading = true;

      const rolesPorPermiso = {
        'FUN_ADMINISTRACION_DE_USUARIOS_COORDINADOR': ['OPERADORSERVICIOS','AGENTCC','SUPERVISOR', 'AGENTCCELITE'],
        'FUN_ADMINISTRACION_DE_USUARIOS_GERENTE': ['OPERADORSERVICIOS', 'AGENTCC', 'SUPERVISOR', 'COORDINADOR', 'AGENTCCELITE'],
        'FUN_ADMINISTRACION_DE_USUARIOS_SUPERVISOR': ['OPERADORSERVICIOS','AGENTCC', 'AGENTCCELITE'],
      };

      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };

      this.$axios
        .post(
          `/v1/agente/filter/list`,
          {
          pagina: this.pagina,
          elementosPagina: this.elementosPagina,
          paginado: true,
          busquedaString: filtros.busquedaString || null,
          rol: filtros.rol || null,
          status: filtros.status || filtros.status === 0 ? filtros.status : null,
          },
          config
        )
        .then((response) => {
          const data = response.data.data;
          const agentesResponse = data.agentes || [];

          this.totalRegistros = data.total || 0;

          if (this.currentRol === "ADMIN") {
            this.rolesPermitidos = [
              "OPERADORSERVICIOS", "AGENTCC", "SUPERVISOR",
              "AGENTCCELITE", "COORDINADOR", "GERENTE", "BACKOFFICE"
            ];
            this.report = agentesResponse;
            this.agents = agentesResponse;
            return;
          }

          let rolesPermitidos = [];

          if (this.currentRol === "ADMINCUENTA") {
            rolesPermitidos = [
              "OPERADORSERVICIOS", "AGENTCC", "AGENTCCELITE",
              "SUPERVISOR", "COORDINADOR", "GERENTE", "BACKOFFICE"
            ];
          } else {
            this.permisos.forEach((permiso) => {
              if (rolesPorPermiso[permiso]) {
                rolesPermitidos = [...rolesPermitidos, ...rolesPorPermiso[permiso]];
              }
            });

            rolesPermitidos = [...new Set(rolesPermitidos)];
          }

          this.rolesPermitidos = rolesPermitidos;
          this.report = agentesResponse;
          this.agents = agentesResponse;
        })
        .catch((error) => {
          console.error("Error al consultar agentes:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    currentItemRol(item) {
      let roles = [];
      item.roles.forEach((element) => {
        if (element.rol != null) {
          roles.push(element.rol);
        }
      });

      if (roles.length > 0) {
        return roles[0];
      } else {
        return "";
      }
    },

    pushItem(item) {
      this.agentes.push({
        uuid: item.uuid,
        id: item.id,
        nombreCompleto: item.nombreCompleto
          ? item.nombreCompleto
          : "No Disponible",
        correo: item.correo ? item.correo : "No Disponible",
        fechaRegistro: item.fechaRegistro
          ? item.fechaRegistro
          : "No Disponible",
        status: item.status,
        roles: Array.isArray(item.roles) && item.roles.length > 0
          ? item.roles.map(r => r.rol || "Desconocido").join(', ') // Convierte array en string
          : "No Disponible",
      });
    },

    editItem(item) {
      this.$router.push(`/usuario/ver-micuenta/${item}`);
    },

    getCurrentRole(roles) {
      let currentRole = "";
      roles.forEach((element) => {
        currentRole += element.rol + " ";
      });
      return currentRole;
    },

    filterOnlyCapsText(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value
          .toString()
          .toLocaleUpperCase()
          .indexOf(search) !== -1
      );
    },

    handleSearch(payload) {
      const busquedaString =
        payload?.correo ||
        payload?.nombre ||
        payload?.apellidoPaterno ||
        payload?.apellidoMaterno ||
        null;

      this.filtrosActuales = {
        busquedaString,
        rol: payload?.rol || null,
        status: payload?.status || payload?.status === 0 ? payload.status : null,
      };

      this.pagina = 1;
      this.getAgent();
    }
  },
};
</script>
<style scoped>
  .header-results{
    border-radius: 20px !important;
    background-color: #f7f8fa;
  }

  .results-table{
    background-color: #f7f8fa;
  }
</style>
